<template>
    <div class="wrapper" data-used-pianos-app id="gallery-app" style="display: none;">
        <a href name="top-of-app"></a>
        <div>
            <navbar/>
            <transition name="fade" mode="out-in">
                <router-view/>
            </transition>
        </div>
    </div>
</template>

<script>
import Navbar from './components/Navbar'

export default {
    name: 'app',
    components: {
        navbar: Navbar,
    },
}
</script>

<style type="text/scss" lang="scss">
// global styles for this Vue app go here.
$fa-font-path: "~font-awesome/fonts";
@import '~font-awesome/scss/font-awesome';
@import url("https://fonts.googleapis.com/css?family=Open+Sans:400,600,700|Armata");
@import 'styles/variables';

.wrapper {
    @import '~bootstrap/scss/bootstrap';
    @import '~bootstrap-vue/dist/bootstrap-vue.css';
    @import 'styles/globals';

    min-height: 750px;

    color: rgba(#000, .7);

    font-family: $font-family-sans-serif;
    font-weight: 400;
    font-size: 16px;

    text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/App.vue